import React from 'react';
import { useSelector } from 'react-redux';
import { useModal } from '../_contexts';
import { Modal } from '../_components';
import { NewTimelineForm } from './forms';

export function NewTimeline(props) {
  const { item: timelineItem, prevModal } = props;
  const { closeModal } = useModal();
  const { chronicle, world } = useSelector((state) => state);

  return (
    <Modal
      id="newTimelineModal"
      // backdrop
      title={!timelineItem ? "New Timeline" : "Edit Timeline"}
      icon="fas fa-bars"
      size="md"
      open={true}
      onClose={() => closeModal(null)}
    >
      <NewTimelineForm
        chronicleID={chronicle.data?._id}
        worldID={world.details?._id}
        item={timelineItem}
        prevModal={prevModal}
      />
    </Modal>
  );
}
